// extracted by mini-css-extract-plugin
export default {"info_area":"InfoArea_info_area__r7OMv"};